<template>
  <div id="app">
    <navigation>
      <router-view></router-view>
    </navigation>
    <AgreementDialog v-if="!$hasFeature('dispatch_order')" />
    <AgreementConfirmDialog v-if="$hasFeature('dispatch_order')" />
  </div>
</template>

<script>

import AgreementDialog from "@/views/agreement-dialog";
import '@/assets/icon/iconfont.css'
import '@/assets/icon/default/iconfont.css'
import '@/assets/icon/iconfont.js'
import AgreementConfirmDialog from "@/views/clerk/agreementConfirmDialog";
export default {
  components: {AgreementConfirmDialog, AgreementDialog},
  data(){
    return{
      roles:null,
      removeClerkRole:null,
    }
  },
  watch: {
    '$route'(to) {
      this.$nextTick(() => {
        // 统一替换标签
        setTimeout(() => {
          this.$replaceLabel(document.body, this.$store.state.label, true)
        }, 200)
      })

      let paths=['register', 'login-weixin', 'login-dingtalk', 'set-token', 'clear-storage', 'noAccount', 'firstVerify','toAlipay','account-verify'];
      let isPaths=false
      for (let i = 0; i < paths.length; i++) {
        if (to.path.includes(paths[i])) {
          isPaths=true;
          break;
        }
      }
      if (!isPaths) {
        this.roles = this.$store.state.roles
        this.removeClerkRole = this.$store.state.removeClerkRole
        if (this.roles == null || this.roles.length == 0) {
          if (this.removeClerkRole) {
            this.$router.replace('/noAccount?type=ClerkDisabled')
          } else {
            this.$router.replace('/noAccount')
          }
        }else if (this.roles.length == 1 && this.hasRole('user')) {
          // 这里是限制只是店员角色 但是已经离职了 就显示离职提示
          if (this.$store.state.isResigned) {
            this.$router.replace('/noAccount?type=ClerkResigned')
          } else if (this.removeClerkRole) {
            this.$router.replace('/noAccount?type=ClerkDisabled')
          } else {
            this.$router.replace('/noAccount')
          }
        }
      }else{
        return;
      }
      //超级管理员路由跳转不做权限校验
      if (this.$hasRole('super_admin')){
        return
      }
      if (to.path.includes("/clerk/")) {
        if (!this.$ClerkAccess.includes(to.meta.menuPermission)) {
          this.gotoNoAccount(to.meta.menuName,'店员')
        }
      } else if (to.path.includes("/leader/")) {
        if (!this.$LeaderAccess.includes(to.meta.menuPermission)) {
          this.gotoNoAccount(to.meta.menuName,'组长')
        }
      } else if (to.path.includes("/guilder/") && !to.path.includes("/guilder/order/detail/")) {
        if (!this.$GuilderAccess.includes(to.meta.menuPermission)) {
          this.gotoNoAccount(to.meta.menuName,'会长')
        }
      } else if (to.path.includes("/kf/")) {
        if (!this.$KfAccess.includes(to.meta.menuPermission)) {
          this.gotoNoAccount(to.meta.menuName,'客服')
        }
      } else if (to.path.includes("/admin/")) {
        if (!this.$AdminAccess.includes(to.meta.menuPermission)) {
          this.gotoNoAccount(to.meta.menuName,'管理员')
        }
      }
    }
  },
  methods:{
    gotoNoAccount(name,role){
      this.$router.push('/noAccount?type=MenuPermission&name='+name+'&role='+role)
    },
    hasRole(role) {
      if (this.roles == null) {
        return false;
      }
      return this.roles.indexOf(role) != -1;
    },
  },
  mounted() {
    if(this.$hasFeature('chat') && this.$store.state.shopSetting.chat.isUsed){
      import('@/views/2184/clerk/chat/roomInfo.vue').then(module => {
        module.default.methods.socketInstance(this.$store);
      });
    }
  },
  updated() {
    this.$nextTick(() => {
      // 统一替换标签
      this.$replaceLabel(document.body, this.$store.state.label, true)
    })
  }
}

</script>


<style lang="less">
  @import 'styles/common.less';
  @import 'styles/global.less';
  @import "https://at.alicdn.com/t/font_2314555_avlcm38ymlu.css";

</style>
